/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

export type PersonalDetailsType = {
  gender: string | null;
  maritalStatus: string | null;
  occupation: string | null;
  incomeSegment: string | null;
  tradingExperience: string | null;
  fatherName: string | null;
  motherName: string | null
  segments: Array<string>
};
export interface PersonalDetailsFormState {
  status: 'idle' | 'loading' | 'success' | 'error';
  personalDetails: PersonalDetailsType,
  savedPersonalDetails: PersonalDetailsType,
  error: {
    isError: boolean,
    type: string | null,
    message: string | null
  }
}

// Initial State

const initialPersonalDetails = {
  gender: null,
  maritalStatus: null,
  occupation: null,
  incomeSegment: null,
  tradingExperience: null,
  fatherName: null,
  motherName: null,
  segments: ["NSE_CM"],
};
const initialState: PersonalDetailsFormState = {
  status: 'idle',
  personalDetails: initialPersonalDetails,
  savedPersonalDetails: initialPersonalDetails,
  error: {
    isError: false,
    type: null,
    message: '',
  },
};

export const personalDetailsFormSlice = createSlice({
  name: 'personalDetailsForm',
  initialState,
  reducers: {
    savePersonalDetails: (state, action) => {},
    setPersonalDetails: (state, action) => {
      state.personalDetails = { ...state.personalDetails, ...action.payload };
    },
    setSavedPersonalDetails: (state, action) => {
      state.personalDetails = action.payload;
      state.savedPersonalDetails = action.payload;
      state.status = 'success';
    },
    clearPersonalDetails: (state) => {
      state.personalDetails = {
        gender: null,
        maritalStatus: null,
        occupation: null,
        incomeSegment: null,
        tradingExperience: null,
        fatherName: null,
        motherName: null,
        segments: ["NSE_CM"],
      };
    },
    setPersonalDetailsFormError: (state, action) => {
      state.error = action.payload;
      state.status = 'error';
    },
    setPersonalDetailsFormStatus: (state, action) => {
      state.status = action.payload;
    },
    clearPersonalDetailsFormError: (state) => {
      state.error = {
        isError: false,
        type: null,
        message: '',
      };
      state.status = 'idle';
    },
  },
});

// Actions
export const {
  setPersonalDetails, clearPersonalDetails, savePersonalDetails, setSavedPersonalDetails,
  setPersonalDetailsFormError, setPersonalDetailsFormStatus, clearPersonalDetailsFormError,
} = personalDetailsFormSlice.actions;

// Slice Reducer
export default personalDetailsFormSlice.reducer;
